import { render } from "./SpecialRequestTable.vue?vue&type=template&id=235d4e9c"
import script from "./SpecialRequestTable.vue?vue&type=script&lang=js"
export * from "./SpecialRequestTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__